import React from 'react'

type SVGProps = React.SVGProps<SVGSVGElement>

export function TwCircleCancel(props: SVGProps) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33398 16.0007C1.33398 7.90047 7.90047 1.33398 16.0007 1.33398C24.1008 1.33398 30.6673 7.90047 30.6673 16.0007C30.6673 24.1008 24.1008 30.6673 16.0007 30.6673C7.90047 30.6673 1.33398 24.1008 1.33398 16.0007Z"
        className="fill-error-350"
      />
      <path
        d="M19.0585 11.0585C19.5792 10.5378 20.4235 10.5378 20.9442 11.0585C21.4647 11.5792 21.4648 12.4236 20.9442 12.9442L17.8866 16.0009L20.9442 19.0585C21.4647 19.5792 21.4648 20.4236 20.9442 20.9442C20.4236 21.4648 19.5792 21.4647 19.0585 20.9442L16.0009 17.8866L12.9442 20.9442C12.4236 21.4648 11.5792 21.4647 11.0585 20.9442C10.5378 20.4235 10.5378 19.5792 11.0585 19.0585L14.1151 16.0009L11.0585 12.9442C10.5378 12.4235 10.5378 11.5792 11.0585 11.0585C11.5792 10.5378 12.4235 10.5378 12.9442 11.0585L16.0009 14.1151L19.0585 11.0585Z"
        className="fill-error-700"
      />
    </svg>
  )
}
